export default {
// Cash Received  提交
getDepositCheckSave:"/accountReceivable/depositCheck/save",
// debit Expense  上传
getDepositCheckUpload:"/accountReceivable/depositCheck/upload",
};
